module.exports = __webpack_public_path__ + "img/bg_01_brown_left.24f87f4a.png";